import { createContext } from "react";

export const FormContext = createContext<Record<string, string>>({});
